"use client";

import { useAppSelector } from "@/store/hooks";
import Script from "next/script";

export default function ABTastyInclude() {
  const abTastyKey = useAppSelector((state) => state.config.abTastyKey);
  if (!abTastyKey) {
    return null;
  }
  return (
    <>
      <Script type="text/javascript" src={`https://try.abtasty.com/${abTastyKey}.js`} strategy="beforeInteractive" />
    </>
  );
}
